// @flow

import React, { type Node, useEffect, useRef } from "react"
import LoadingIcon from "./LoadingIcon"

type Props = {
  isLoading?: boolean,
  fetchMore: () => Promise<any> | void,
  children: Node
}

const InfiniteScroll = (props: Props): Node => {
  const { isLoading, fetchMore, children } = props

  const loaderRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const target = entries[0]
      if (target.isIntersecting) {
        fetchMore()
      }
    })

    if (loaderRef.current) {
      observer.observe(loaderRef.current)
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current)
      }
    }
  }, [fetchMore])

  return (
    <>
      {children}
      <div ref={loaderRef}>{isLoading && <LoadingIcon />}</div>
    </>
  )
}

export default InfiniteScroll
